import React, { useEffect, useState, useMemo, Fragment } from "react";
import Select from 'react-select';
import Form from 'react-bootstrap/Form';
import DatePicker from "react-datepicker";
import { Country, State }  from 'country-state-city';

export default function RegistrationForm(props) {

  const countries = useMemo(() => Country.getAllCountries().map(c=>{ return {value: c.name, label: c.name}}), [])

  const [docExpiryDate, setDocExpiryDate] = useState(null);
  const [birthDate, setBirthDate] = useState(null);
  const [insuranceExpiryDate, setInsuranceExpiryDate] = useState(null); 
  const [visaStartDate, setVisaStartDate] = useState(null); 
  const [visaEndDate, setVisaEndDate] = useState(null); 

  const [idTypeValid, setIdTypeValid] = useState(false);
  const [nationalityValid, setNationalityValid] = useState(false);
  const [residenceValid, setResidenceValid] = useState(false);
  const [passportCountryValid, setPassportCountryValid] = useState(false);
  const [insuranceCountryValid, setInsuranceCountryValid] = useState(false);
  const [ecCountryValid, setEcCountryValid] = useState(false);
  const [arrivalTimeCarValid, setArrivalTimeCarValid] = useState(false);
  const [arrivalTimeTrainValid, setArrivalTimeTrainValid] = useState(false);
  const [departureTimeCarValid, setDepartureTimeCarValid] = useState(false);
  const [departureTimeTrainValid, setDepartureTimeTrainValid] = useState(false);

  const [arrivalWay, setArrivalWay] = useState(null);
  const [departureWay, setDepartureWay] = useState(null);

  const [medicalConditionsYesNo, setMedicalConditionsYesNo] = useState(null);
  const [allergiesYesNo, setAllergiesYesNo] = useState(null);
  const [hospitalisationYesNo, setHospitalisationYesNo] = useState(null);
  const [physicalYesNo, setPhysicalYesNo] = useState(null);
  const [allergiesMedicationYesNo, setAllergiesMedicationYesNo] = useState(null);
  const [closeShowersYesNo, setCloseShowersYesNo] = useState(null);
  const [partnerAppliedYesNo, setPartnerAppliedYesNo] = useState(null);
  const [partnerInvitedYesNo, setPartnerInvitedYesNo] = useState(null);
  const [doubleHutYesNo, setDoubleHutYesNo] = useState(null);
  const [smokingYesNo, setSmokingYesNo] = useState(null);
  const [glutenFreeYesNo, setGlutenFreeYesNo] = useState(null);

  const validateFile = (el)=> {
    if (el.files.length && el.files[0].size>4*1024*1024) {
      el.setCustomValidity('File is too large. Maximum 4MB please.');
      el.classList.add('invalid');
    } else {
      el.setCustomValidity('');
      el.classList.remove('invalid');
    }
  }

  const validatePhone = (el)=> {
    var regexp = /^[\s()+-]*([0-9][\s()+-]*){6,20}$/;
    var isValid = regexp.test(el.value);

    el.setCustomValidity(isValid ? '' : 'Please enter a valid phone number');
    el.classList.toggle('invalid', !isValid);
  }  

  const validatePolicyNumber = (el) => {
    var regexp = /^[a-zA-Z0-9\s]+$/;
    var isValid = regexp.test(el.value);

    el.setCustomValidity(isValid ? '' : 'Please enter only letters, numbers and spaces');
    el.classList.toggle('invalid', !isValid);
  }

  return (

    <Form noValidate className='registration-form'>
      <h2>Travel Documents</h2>
      {props.isOpenBooking ?
      <Fragment>
      <div>
          <label className='required'>Nationality</label>
          <Select required name="Nationality" className={nationalityValid ? 'valid' : 'invalid'} onChange={()=>setNationalityValid(true)} options={countries} />
      </div>
      <div>
          <label className='required'>Country of Residence</label>
          <Select required name="Country_of_Residence" className={residenceValid ? 'valid' : 'invalid'} onChange={()=>setResidenceValid(true)} options={countries} />
      </div>
      <div>
        <label className='required'>Date of Birth</label>
        <DatePicker name="Date_of_Birth" onKeyDown={(e) => { e.preventDefault();}} selected={birthDate} onChange={(date)=>setBirthDate(date)} className="form-control" dateFormat="dd MMM, yyyy" calendarStartDay={1} required showYearDropdown scrollableYearDropdown yearDropdownItemNumber={100} maxDate={new Date()} />
      </div>
      </Fragment> : <span></span>}
      <div>
          <label className='required'>Type of ID (Passport, EU ID, etc.)</label>
          <Select required name="Type_of_Document" className={idTypeValid ? 'valid' : 'invalid'} onChange={()=>setIdTypeValid(true)} options={['Passport', 'EU ID'].map(v=>{ return {value: v, label: v}})} />
      </div>
      <div>
          <label className='required'>Passport / Document Issued By</label>
          <Select required name="Issued_By" className={passportCountryValid ? 'valid' : 'invalid'} onChange={()=>setPassportCountryValid(true)} options={countries} />
      </div>
      <div>
          <label className='required'>ID or Passport Number</label>
          <Form.Control name="ID_or_Passport_Number" type="text" required />
      </div>
      <div>
        <label className='required'>Document Expiration Date</label>
        <DatePicker name="Document_Expiration_Date" onKeyDown={(e) => { e.preventDefault();}} selected={docExpiryDate} onChange={(date)=>setDocExpiryDate(date)} className="form-control" dateFormat="dd MMM, yyyy" calendarStartDay={1} required showYearDropdown scrollableYearDropdown yearDropdownItemNumber={50} minDate={new Date()} />
      </div>
      <div>
        <label className='required'>Please upload an image of your passport or ID</label>
        <Form.Control name="idPhoto" type="file" accept="image/jpeg" required onChange={(e)=>validateFile(e.target)}/>
        <span className='form-field-info'>Only jpeg and jpg files allowed. Max size 4MB</span>
      </div>
      
      {false && !props.isOpenBooking && props.registrationFormType!='simple' ?
      <Fragment>
        <h2>Visa Information</h2>
        <span className='form-field-info'>If you come from one of the countries that require a Visa for Portugal, please provide the dates of your Visa allowance.</span>

        <div>
          <label>Visa Start Date</label>
          <DatePicker name="Visa_Start_Date" onKeyDown={(e) => { e.preventDefault();}} selected={visaStartDate} onChange={(date)=>setVisaStartDate(date)} dateFormat="dd MMM, yyyy" calendarStartDay={1} />
        </div>
        <div>
          <label>Visa End Date</label>
          <DatePicker name="Visa_End_Date" onKeyDown={(e) => { e.preventDefault();}} selected={visaEndDate} onChange={(date)=>setVisaEndDate(date)} dateFormat="dd MMM, yyyy" calendarStartDay={1} />
        </div>
      </Fragment> : <span></span>}

      {false && !props.isOpenBooking && props.registrationFormType!='simple' ?
      <Fragment>
      <h2>Health Insurance Information</h2>
      <span className='form-field-info'>Please list details for the health insurance that will cover you during your stay in Portugal.</span>

      <div>
        <label className='required'>Insurance Company Name</label>
        <Form.Control name="Insurance_Name" type="text" required />
      </div>
      <div>
        <label className='required'>Policy Number</label>
        <Form.Control name="Insurance_Policy_Num" type="text" required />
      </div>    
      <div>
          <label className='required'>Country Where Issued</label>
          <Select required name="Insurance_Country" className={insuranceCountryValid ? 'valid' : 'invalid'} onChange={()=>setInsuranceCountryValid(true)} options={countries} />
      </div>
      <div>
        <label className='required'>Expiration Date</label>
        <DatePicker name="Insurance_Exp_Date" onKeyDown={(e) => { e.preventDefault();}} selected={insuranceExpiryDate} onChange={(date)=>setInsuranceExpiryDate(date)} className="form-control" dateFormat="dd MMM, yyyy" calendarStartDay={1} required showYearDropdown scrollableYearDropdown yearDropdownItemNumber={50} />
      </div>
      <div>
        <label className='required'>Insurance Contact Phone</label>
        <Form.Control name="Insurance_Contact_Phone2" type="text" required/>
      </div>             
      <div>
        <label className='required'>Photo of Insurance card</label>
        <Form.Control name="insurancePhoto" type="file" accept="image/jpeg,image/gif,image/png,application/pdf" required onChange={(e)=>validateFile(e.target)} />
        <span className='form-field-info'>Images and PDF files allowed. Max size 4MB</span>
      </div>
      </Fragment> : <span></span>}

      {props.isOpenBooking || props.registrationFormType!='simple' ?
      <Fragment>
        <h2>Emergency Contact</h2>
        <div>
          <label className='required'>Emergency Contact First name</label>
          <Form.Control name="EC_First_Name" type="text" required />
        </div> 
        <div>
          <label className='required'>Emergency Contact Last name</label>
          <Form.Control name="EC_Last_Name" type="text" required />
        </div> 
        <div>
          <label className='required'>Relationship to You</label>
          <Form.Control name="EC_Relationship" type="text" required />
        </div> 
        <div>
          <label className='required'>Emergency Contact Email</label>
          <Form.Control name="EC_Email" type="text" required />
        </div> 
        <div>
          <label className='required'>Emergency Contact Phone</label>
          <Form.Control name="EC_Phone" type="text" onChange={(e)=>validatePhone(e.target)} required />
        </div> 
        <div>
            <label className='required'>Emergency Contact Country</label>
            <Select required name="EC_Country" className={ecCountryValid ? 'valid' : 'invalid'} onChange={()=>setEcCountryValid(true)} options={countries} />
        </div>
      </Fragment> : <span></span>}

      {!props.isOpenBooking && props.registrationFormType!='simple' ?
        <Fragment>
          <h2>Health Insurance</h2>
          <span className='form-field-info'>We require everyone staying on the land to have a valid health insurance policy.</span>
          <div>
            <Form.Check type='checkbox' id='Health_insurance_chk' name="Health_insurance_chk" value="true" required label='I confirm that I have valid health insurance coverage for the entire duration of my stay in Monte Sahaja'/>   
          </div>
        </Fragment>
      : <span></span>}

      {!props.isOpenBooking && props.registrationFormType!='simple' ?
      <Fragment>
      <h2>Health Conditions</h2>
      <p>Monte Sahaja is located in a remote region of Portugal. The closest hospital is an hour’s drive away and emergency services can take over an hour to arrive. For these reasons, we ask all coming to Monte Sahaja to fill out the following questions honestly and completely in order to ensure a comfortable and safe stay here. </p>
      <span className='form-field-info' style={{fontSize: '90%', fontStyle: 'italic'}}>The information you give regarding health will be deleted 6 months after leaving Monte Sahaja, according to our Privacy Policy.</span>

      <div>
          <label className='required'>Do you have any current medical conditions<br/> (physical or mental)?</label>
          <Select required name="Medical_conditions_Yes_No" className={medicalConditionsYesNo!=null ? 'valid' : 'invalid'} onChange={(op)=>{setMedicalConditionsYesNo(op.value=='Yes')}} options={['Yes', 'No'].map(v=>{ return {value: v, label: v}})} />
      </div>

      {medicalConditionsYesNo ? 
        <div>
            <label className='required'>If yes, please provide further information.</label>
            <Form.Control name="Med_Conditions_reg" as="textarea" rows={3} required />
        </div> : <span></span> }

      <div>
          <label className='required'>Have any of these conditions ever required hospitalisation?</label>
          <Select required name="Hospitalisation_Yes_No" className={hospitalisationYesNo!=null ? 'valid' : 'invalid'} onChange={(op)=>setHospitalisationYesNo(op.value=='Yes')} options={['Yes', 'No'].map(v=>{ return {value: v, label: v}})} />
      </div>

      {hospitalisationYesNo ? 
        <div>
            <label className='required'>If yes, please provide further information.</label>
            <Form.Control name="Occupation_Experience" as="textarea" rows={3} required />
        </div> : <span></span> }

      <div>
          <label className='required'>Do you have any allergies (food, medication,<br/> environmental etc.)?</label>
          <Select required name="Allergies" className={allergiesYesNo!=null ? 'valid' : 'invalid'} onChange={(op)=>setAllergiesYesNo(op.value=='Yes')} options={['Yes', 'No'].map(v=>{ return {value: v, label: v}})} />
      </div>

      {allergiesYesNo ? 
        <div>
            <label className='required'>If so, do you require medication for them?</label>
            <Select required name="Medication_for_Allergies" className={allergiesMedicationYesNo!=null ? 'valid' : 'invalid'} onChange={(op)=>setAllergiesMedicationYesNo(op.value=='Yes')} options={['Yes', 'No'].map(v=>{ return {value: v, label: v}})} />
        </div> : <span></span> }      

      <p><b>If you take any prescribed medication for regular or emergency use, please make sure you bring enough for your entire stay in Monte Sahaja.​</b> Also note that although the accommodations have lights, they are mostly without electric power points.</p>

      {props.registrationFormType=='default' || props.registrationFormType=='Guest Stay May 2026' ?
      <Fragment>
        <div>
            <label className='required'>Do you have any health conditions where the facilities at Monte Sahaja may be challenging (eg the showers and toilets are usually some distance from accommodation, may involve steps)?</label>
            <Select required name="Physical_Conditions" className={physicalYesNo!=null ? 'valid' : 'invalid'} onChange={(op)=>setPhysicalYesNo(op.value=='Yes')} options={['Yes', 'No'].map(v=>{ return {value: v, label: v}})} />
        </div> 
        
        <p>If yes, please be in contact with us (<a href='mailto:sahaja.invitations@mooji.org'>sahaja.invitations@mooji.org</a>) so we can see how we can support you.</p>
      </Fragment>: <span></span> }

      {props.registrationFormType=='Guest Stay September 2026' ?
      <Fragment>
        <div>
          <label className='required'>Our toilets and showers are a short walk from the accommodation, up to 100-200 meters, and sometimes accessed by steps. We have a limited number of spaces closer to these facilities. Do you need to be close to toilets and showers (e.g. for a health condition or mobility reasons)?</label>
          <Select required name="Needs_close_to_showers" className={closeShowersYesNo!=null ? 'valid' : 'invalid'} onChange={(op)=>setCloseShowersYesNo(op.value=='Yes')} options={['Yes', 'No'].map(v=>{ return {value: v, label: v}})} />
        </div>
        <div/>
        <div>
          <label className='required'>Do you smoke? If you do smoke, we will do our best to give you an accommodation near a smoking area. Note that tobacco is not sold in our shop.</label>
          <Select required name="Smoking" className={smokingYesNo!=null ? 'valid' : 'invalid'} onChange={(op)=>setSmokingYesNo(op.value=='Yes')} options={['Yes', 'No'].map(v=>{ return {value: v, label: v}})} />
        </div>
        <div/>
      </Fragment> : <span></span> }
      {false ?
        <Fragment>
          <div>
            <label className='required'>Are you applying together with your partner?</label>
            <Select required name="Partner_Applied" className={partnerAppliedYesNo!=null ? 'valid' : 'invalid'} onChange={(op)=>setPartnerAppliedYesNo(op.value=='Yes')} options={['Yes', 'No'].map(v=>{ return {value: v, label: v}})} />
          </div>
          <div></div>
          {partnerAppliedYesNo ?
          <Fragment>
            <div>
              <label className='required'>If Yes, did your partner also receive an invitation?</label>
              <Select required name="Partner_Invited" className={partnerInvitedYesNo!=null ? 'valid' : 'invalid'} onChange={(op)=>setPartnerInvitedYesNo(op.value=='Yes')} options={['Yes', 'No'].map(v=>{ return {value: v, label: v}})} />
            </div>
            <div>
              <label className='required'>Partner's name:</label>
              <Form.Control name="Partner_s_Name" type="text" required/>
            </div>
            {partnerInvitedYesNo ?
            <div>
              <label className='required'>Would you like to share a double hut? (Very limited availability)</label>
              <Select required name="Double_Hut" className={doubleHutYesNo!=null ? 'valid' : 'invalid'} onChange={(op)=>setDoubleHutYesNo(op.value=='Yes')} options={['Yes', 'No'].map(v=>{ return {value: v, label: v}})} />
            </div> : <span></span>}
          </Fragment> : <span></span> }
        
       </Fragment> : <span></span> }

      {props.registrationFormType=='default' ?
      <div>
          <label className='required'>For ARRIVAL: will you take the train to Funcheira, or will you arrive by car?</label>
          <Select required name="Arr_Transport_Type" className={arrivalWay!=null ? 'valid' : 'invalid'} onChange={(w)=>setArrivalWay(w.value)} options={['Train', 'Car'].map(v=>{ return {value: v, label: v}})} />
      </div> : <span></span>}
      {props.registrationFormType=='Guest Stay September 2026' ?
      <Fragment>
        <h2>Transport</h2>
        <h3 style={{color: 'rgb(11, 83, 148)'}}>ARRIVAL</h3>
        <p><b>By Sahaja Transport</b></p>
        <p>We are providing buses departing at <b>08:30 on 22 September</b> from <b>Lisbon Airport</b> and <b>nearby the Faro Bus Station</b>. If you select this option, we will send you detailed information closer to the time.</p>
        <p><b>By Your Own Transportation</b></p>
        <p>To help support an organised and efficient arrival, it is our preference that everyone travels together by bus, but you can also arrive by <b>car or taxi</b>. In this case, you must arrive at Monte Sahaja between 09:00-10:00 on 22 September.</p>
        <p>Estimated taxi costs: Lisbon to Sahaja: €230 / Faro to Sahaja: €140. Monte Sahaja is about 2.5 hours from Lisbon and 2 hours from Faro.</p>
        <p><b>Note it is not possible to arrive by train on 22 September, as they do not run early enough.</b></p>
        <h3 style={{color: 'rgb(11, 83, 148)'}}>DEPARTURE</h3>
        <p>On the 1 October, buses will depart Sahaja between 10:30-11:30 for Lisbon airport (arriving by 14:00) and Faro airport (arriving by 13:30).</p>
        <p>If you are departing with your own transportation, you must leave Sahaja before 10:00 or between 11:00-12:00 on 22 September.</p>

        <div>
            <label className='required'>Please select how you plan to arrive:</label>
            <Select required name="Arr_Transport_Type" className={arrivalWay!=null ? 'valid' : 'invalid'} onChange={(w)=>setArrivalWay(w.value)} options={['I will take the bus from Lisbon (08:30, 22 September)', 'I will take the bus from Faro (08:30, 22 September)', 'I will be dropped off by a taxi/friend (between 09:00-10:00, 22 September)', 'I will arrive by car and need to park (between 09:00-10:00, 22 September)'].map(v=>{ return {value: v, label: v}})} />
        </div> 
      </Fragment>: <span></span>}

      {props.registrationFormType=='Guest Stay May 2026' ?
      <Fragment>
        <h2>Transport</h2>
        <h3 style={{color: 'rgb(11, 83, 148)'}}>ARRIVAL</h3>
        <p style={{fontStyle: 'italic', marginTop: 10}}>Guests are asked to arrive at Monte Sahaja by 12:30 on <b>19 May</b>.</p>
        <p><b>Arrival By Train at Funcheira Station</b></p>
        <p>If you are flying into Portugal, consider flights that land early enough in Lisbon or Faro to catch one of the trains mentioned below. <b>Though there are later trains, please only take one of these trains.</b> In order to be on time to catch these trains, you may need to stay overnight in Lisbon or Faro.</p>
        <p>For the following trains only, we will arrange a pick up from Funcheira train station to Monte Sahaja.</p>
        <p><b>Arrival By Car or Taxi</b></p>
        <p>If you come by car or taxi, please arrive between 10:30-12:30.</p>
        <p><em>Check your flights, before answering the below.</em></p>
        <div>
            <label className='required'>Please select how you plan to arrive:</label>
            <Select required name="Arr_Transport_Type" className={arrivalWay!=null ? 'valid' : 'invalid'} onChange={(w)=>setArrivalWay(w.value)} options={['⁠⁠I will arrive by train at 11:56 from Lisbon', ' ⁠⁠I will arrive by train at 09:55 from Faro', '⁠⁠⁠⁠I will arrive by taxi/car between 10:30 - 12:30'].map(v=>{ return {value: v, label: v}})} />
        </div><span/>
        <p></p>        
        <h3 style={{color: 'rgb(11, 83, 148)'}}>DEPARTURE</h3>
        <p>For your departure on <b>29 May</b> we will provide rides to Funcheira for the following trains:</p>
        <ul>
          <li>10:01 and 15:54 trains to Lisbon (arriving at Lisbon Oriente at 11:56 and 17:56)</li>
          <li>11:57 and 15:54 trains to Faro (arriving at Faro at 13:30 and 17:35)</li>
        </ul>
        <div>
          <label className='required'>Please select how you plan to depart:</label>
          <Select required name="Dep_Transport_Type" className={departureWay!=null ? 'valid' : 'invalid'} onChange={(w)=>setDepartureWay(w.value)} options={['I will take the 10:01 train to Lisbon', 'I will take the 15:54 train to Lisbon', 'I will take the 11:57 train to Faro', 'I will take the 15:54 train to Faro', '⁠I will leave by car/taxi'].map(v=>{ return {value: v, label: v}})} />
        </div><span />
      </Fragment>: <span></span>}      
      <div />

      {arrivalWay=='Car' ?
        <Fragment>
          {props.registrationFormType=='default' ?
          '' :
          <p>If you arrive by car, please plan your arrival at Monte Sahaja for <b>11:30am</b>. We will send you driving and parking instructions closer to your arrival time.</p> }
          {props.registrationFormType=='default' ?
          <div>
            <label className='required'>If you arrive by car, please let us know your arrival time:</label>
            <Select required name="Car_Arrival_Time" className={arrivalTimeCarValid ? 'valid' : 'invalid'} onChange={()=>setArrivalTimeCarValid(true)} options={['09:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00'].map(v=>{ return {value: v, label: v}})} />
          </div> : <div></div>}
          <div />
        </Fragment> : <span></span>}

      {arrivalWay=='Train' ?
        <Fragment>
          <p>Please select your train times below. You will have the opportunity to update them later, but please do not change your plans without notifying us. <br/>From Funcheira station you may take a taxi to Monte Sahaja.</p>
          <div>
            <label className='required'>Arrival Time at Funcheira Station</label>
            <Select required name="Arrival_Time" className={arrivalTimeTrainValid ? 'valid' : 'invalid'} onChange={()=>setArrivalTimeTrainValid(true)} options={['11:56 From Lisbon', '15:48 From Faro', '15:53 From Lisbon'].map(v=>{ return {value: v, label: v}})} />
          </div>
        <div />
        </Fragment> : <span></span>}   


      {arrivalWay=='Bus' && props.registrationFormType=='Lisbon 2024' ?
        <Fragment>
          <div>
            <p><strong>Meeting Point: Aula Magna main entrance.</strong><br/>
            <strong>Time: 8:30am on Monday, 8 April.</strong></p>
            <p>The cost for the bus is <em>€20</em>.</p>
          </div>
          <div />
        </Fragment> : <span></span>}                  

      {props.registrationFormType=='default' ?
      <Fragment>
        <div>
          <label className='required'>For DEPARTURE: will you take the train from Funcheira, or will you depart by car?</label>
          <Select required name="Dep_Transport_Type" className={departureWay!=null ? 'valid' : 'invalid'} onChange={(w)=>setDepartureWay(w.value)} options={['Train', 'Car'].map(v=>{ return {value: v, label: v}})} />
        </div>
        <div />
      </Fragment> : <Fragment /> }

      {props.registrationFormType=='Guest Stay September 2026' ?
        <Fragment>
          <div>
            <label className='required'>Please select how you plan to depart:</label>
            <Select required name="Dep_Transport_Type" className={departureWay!=null ? 'valid' : 'invalid'} onChange={(w)=>setDepartureWay(w.value)} options={['I will take the bus to Lisbon airport (arriving by 14:00, 1 October)', 'I will take the bus to Faro airport (arriving by 13:30, 1 October)', 'I will leave by car/taxi before 9:30 or between 11:30-12:30 on 1 October'].map(v=>{ return {value: v, label: v}})} />
          </div> 
          <div />
      </Fragment> : <Fragment /> }

      {departureWay=='Car' ?
        <Fragment>
          <div>
            <label className='required'>Departure Time by Car</label>
            <Select required name="Car_Departure_Time" className={departureTimeCarValid ? 'valid' : 'invalid'} onChange={()=>setDepartureTimeCarValid(true)} options={['08:00-10:00', '10:00-12:00', '14:00-15:00', '15:00-17:00', '17:00-20:00'].map(v=>{ return {value: v, label: v}})} />
          </div>
        </Fragment> : <span></span>}

      {departureWay=='Train' ?
        <Fragment>
          <div>
            <label className='required'>Departure Time from Funcheira Station</label>
            <Select required name="Departure_Time" className={departureTimeTrainValid ? 'valid' : 'invalid'} onChange={()=>setDepartureTimeTrainValid(true)} options={['8:21 To Lisbon', '10:01 To Lisbon', '11:57 To Faro', '15:54 To Lisbon', '15:54 To Faro', '19:54 To Lisbon','20:24 To Faro'].map(v=>{ return {value: v, label: v}})} />
          </div>
        </Fragment> : <span></span>}    

      {false ?
        <Fragment>
          <h2>Seva</h2>
          <p>Would you like to participate in some light seva opportunities to take part in daily tasks with the sangha such as cleaning, dishwashing, or food preparation?</p>
          <div className='seva-choices'>
            <Form.Check type='checkbox' id='Food_preparation' name="Food_preparation" value="true" label='Food preparation'/>
            <Form.Check type='checkbox' id='Sweeping' name="Sweeping" value="true" label='Sweeping'/>
            <Form.Check type='checkbox' id='Cleaning' name="Cleaning" value="true" label='Cleaning'/>
            <Form.Check type='checkbox' id='Dishwashing' name="Dishwashing" value="true" label='Dishwashing'/>
            <Form.Check type='checkbox' id='Raking' name="Raking" value="true" label='Raking'/>
          </div>
        </Fragment> : <span></span>}

      {!props.isOpenBooking && (props.registrationFormType=='Guest Stay September 2025' || props.registrationFormType=='Guest Stay June 2026' || props.registrationFormType=='Guest Stay September 2026') ?
        <Fragment>
            <h2>Dietary Preferences</h2>
            <p><b>Meals</b><br/>Our dining hall provides delicious, nourishing vegetarian meals. We serve a good variety of fresh vegetables, grains, and beans.</p>

            <p><b>Special Diets</b><br/>We are able to cater for vegan, gluten-free, dairy-free, soy-free and nut-free diets. Please understand that we cannot provide for diets more specific than this. However, if you do have any further medical dietary restrictions like food allergies, please inform our kitchen team by emailing <a href='mailto:sahajakitchen@mooji.org' target='_blank'>sahajakitchen@mooji.org</a> and reminding someone from the kitchen in person once you are in Sahaja.</p>

          <div className='dietary-choices'>
              {/* <Form.Check type='checkbox' id='vegetarian' name="Vegetarian" value="true" label='Vegan'/> */}
              {/* <Form.Check type='checkbox' id='fishChicken' name="Fish_Eater" value="true" label='I eat fish'/> */}
              {/* <Form.Check type='checkbox' id='glutenFree' name="Gluten_Free" value="true" label='Gluten Free'/> */}
              {/* <Form.Check type='checkbox' id='dairyFree' name="Dairy_Free" value="true" label='Dairy Free'/> */}
              <label className='required'>Do you eat gluten free?</label>
              <Select required name="Gluten_Free_Yes_No" className={glutenFreeYesNo!=null ? 'valid' : 'invalid'} onChange={(op)=>setGlutenFreeYesNo(op.value=='Yes')} options={['Yes', 'No'].map(v=>{ return {value: v, label: v}})} />
          </div>
        </Fragment>:<span></span>}
      </Fragment> : <span></span>}

      {/* <h2>Terms & Conditions</h2> */}
      {/* <span className='form-field-info'>Please carefully read the <a href='https://documents.mooji.org/TC_Reception.pdf' target='_blank'>Terms and Conditions</a>.</span> */}
      <div className='terms' style={{margin: 0}}>
          <Form.Control type='hidden' name="Terms_reg" value="true" />	
          <Form.Control type='hidden' name="Privacy_Policy" value="true" />	
      </div>      
    </Form>
  );
}